import Vuex from 'vuex';
import Vue from 'vue';
import reference from './modules/reference';
import auth from './modules/auth';
import create from './modules/create';
import cabinet from './modules/cabinet';
import pages from './modules/pages';
import partner from './modules/partner/partner';
import createPartner from "./modules/partner/createPartner";
import master from './modules/master/master';
import createMaster from './modules/master/createMaster';
import user from './modules/user';
import miniProfile from './modules/miniProfile';
import profile from './modules/profile';
import blank from "./modules/blank";
import burial from "./modules/burial";
import cemetery from "./modules/cemetery";
import remoteHost from "./modules/remoteHost";
import remoteDb from "./modules/remoteDb";
import home from "./modules/home"
import news from "./modules/news/news";
import createNews  from "./modules/news/createNews";
import categories from "./modules/news/categories";
import locations from "./modules/location/locations";
import createLocation from "./modules/location/createLocation";
import {Lang} from "../utils/lang";
import banner from "./modules/banner";
import memorials from "./modules/memorial/memorials";
import memorialTypes from "./modules/memorial/memorialTypes";
import createMemorial from "./modules/memorial/createMemorial";
import langs from "./modules/langs";
import header from "./modules/header";
import articles from "./modules/articles/articles";
import articleCategories from "./modules/articles/categories";
import createArticle from "./modules/articles/createArticle";
import promoCode from "./modules/promoCode";
import pageRedirect from "./modules/pageRedirect";
import welcome from "./modules/welcome";
import archive from "./modules/archive";
import subscribe from "./modules/subscribe";
import treeBlank from './modules/treeBlank';
import treeRedirect from "./modules/treeRedirect";
import subscriptionPromoCodeBlank from "./modules/subscriptionPromoCodeBlank"
import subscription from "./modules/subscription";
import widgetDostavka from "./modules/widgetDostavka";

Vue.use(Vuex);
Vue.use(Lang);

export const store = new Vuex.Store({
    modules: {
        auth,
        articles,
        articleCategories,
        reference,
        create,
        cabinet,
        pages,
        partner,
        createArticle,
        createPartner,
        master,
        createMaster,
        user,
        blank,
        burial,
        cemetery,
        miniProfile,
        profile,
        remoteHost,
        remoteDb,
        home,
        news,
        createNews,
        categories,
        locations,
        createLocation,
        banner,
        memorials,
        memorialTypes,
        createMemorial,
        langs,
        header,
        promoCode,
        pageRedirect,
        welcome,
        archive,
        subscribe,
        treeBlank,
        treeRedirect,
        subscriptionPromoCodeBlank,
        subscription,
        widgetDostavka
    },
});
